import React from "react";
import styled from "styled-components";
import Skeleton from "react-loading-skeleton";

const Item = styled.div`
    display: flex;
    flex-direction: column;
    width: 50%;
    margin: 0;
    padding: 15px 7.5px 25px 7.5px;

    @media (min-width: 540px) {
        width: 33.33%;
    }
`;

function SkeletonEditItem() {
    return (
        <Item>
            <Skeleton
                style={{
                    display: "block",
                    width: "100%",
                    height: "350px"
                }}
            />
        </Item>
    );
}

export default SkeletonEditItem;
